/**
 * leaflet.markercluster tem build UMD antigo que lê `L` direto do escopo global em vez de
 * importar 'leaflet'. Sem isso o plugin lança "L is not defined" com bundlers ESM (rsbuild/
 * rspack). Import só por efeito colateral, precisa vir antes de `import 'leaflet.markercluster'`
 * (a ordem de avaliação entre declarações `import` no topo de um módulo é garantida pela spec
 * de ES modules).
 */
import Leaflet from 'leaflet'
;((window as unknown) as { L: typeof Leaflet }).L = Leaflet
